import 'mathlive/dist/mathlive.min';
import * as React from 'react';
import Box from '@mui/material/Box';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Grid,
  Tabs,
  Tab,
} from '@mui/material';
import { MathfieldComponent } from 'react-mathlive';
// MODALS
import ModalButtons from './ModalButtons';
// CONSTANTS
import { tabNames } from '../../../../../../constants';

export interface IEquationAddModal {
  latex: string;
  toggleButton: string;
}

export interface IProps {
  close: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  AddEquation: (text: any) => void;
  openStatus: boolean;
}

const style = {
  addButton: {},
  cancelButton: {
    marginRight: '15px',
  },
};

class EquationAddModal extends React.Component<IProps, IEquationAddModal> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      latex: '',
      toggleButton: 'quick',
    };
    // INIT METHODS
    this.handleClose = this.handleClose.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.onMathChange = this.onMathChange.bind(this);
    this.handleLatex = this.handleLatex.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleClose(): void {
    const { close } = this.props;
    close();
    this.setState({
      latex: '',
    });
  }

  handleClick(): void {
    const { latex } = this.state;
    const { close, AddEquation } = this.props;
    close();
    AddEquation(latex);
    this.setState({
      latex: '',
    });
  }

  // eslint-disable-next-line
  handleLatex(text: any): void {
    const { latex } = this.state;
    this.setState({
      latex: latex.concat(text),
    });
  }

  // eslint-disable-next-line
  handleToggle(event, toggle): void {
    this.setState({
      toggleButton: toggle,
    });
  }

  // eslint-disable-next-line
  onMathChange(mathText): void {
    this.setState({
      latex: mathText,
    });
  }

  render(): JSX.Element {
    const { openStatus } = this.props;
    const { toggleButton, latex } = this.state;

    return (
      <Dialog
        onClose={this.handleClose}
        open={openStatus}
        PaperProps={{
          sx: {
            m: {
              xs: '0',
              sm: '30px',
            },
            minHeight: {
              xs: '100vh',
              sm: '66vh',
            },
            minWidth: {
              lg: '80vw',
              sm: 'unset',
            },
          },
        }}
      >
        <DialogTitle>Equation Editor</DialogTitle>
        <DialogContent sx={{ p: '15px', overflowY: 'unset' }}>
          <Box>
            <Tabs
              value={toggleButton}
              onChange={this.handleToggle}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              allowScrollButtonsMobile
            >
              {tabNames &&
                tabNames.map((tab, index) => {
                  return <Tab key={index} label={tab.name} value={tab.value} />;
                })}
            </Tabs>
            <ModalButtons
              addLatex={this.handleLatex}
              toggleTabs={toggleButton}
            />
            <div>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <div
                    style={{
                      border: '1px solid black',
                      borderRadius: '5px',
                      height: '50px',
                      marginTop: '10px',
                      marginBottom: '10px',
                    }}
                  >
                    <MathfieldComponent
                      onChange={this.onMathChange}
                      latex={latex}
                    />
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ display: 'flex', justifyContent: 'right' }}
                >
                  <Button
                    sx={style.cancelButton}
                    variant="outlined"
                    onClick={this.handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    sx={style.addButton}
                    variant="contained"
                    onClick={this.handleClick}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    );
  }
}

export default EquationAddModal;
